import React from "react";
import { debounce as d } from "lodash";
import { Control, actions } from "react-redux-form";
import { Button, PopoverBody } from "reactstrap";
import Select from "react-select";
import { Trans, withTranslation } from "react-i18next";
import { withPopover } from "components/common";
import { compose, withStateHandlers, withHandlers } from "recompose";
import { XeroClient } from "services";
import { NotificationManager } from "react-notifications";

export const ContactSearch = compose(
  withPopover(),
  withTranslation(),
  withStateHandlers(
    { newContact: "" },
    {
      setNewContact: () => (e) => ({ newContact: e.target.value }),
    }
  ),
  withHandlers({
    getProps: (props) => () => props,
  }),
  withHandlers({
    handleAddNewContact:
      ({ newContact, dispatch, getProps, togglePopover, setNewContact, t }) =>
      () => {
        const client = XeroClient();
        client
          .post("contacts", {
            Name: newContact,
          })
          .then(
            (resp) => {
              dispatch(actions.change("local.Contact", resp.data));

              if (getProps().isPopoverOpen) {
                togglePopover();
              }
              setNewContact({ target: { value: "" } });
            },
            (err) => {
              NotificationManager.warning(
                t(
                  "Unable to add the contact, make sure the name does not already exist."
                )
              );
            }
          );
      },
  })
)(
  ({
    loadContactOptions,
    Popover,
    togglePopover,
    t,
    setNewContact,
    newContact,
    handleAddNewContact,
    ...props
  }) => (
    <div aria-disabled={props.disabled}>
      <Control.text
        component={Select.Async}
        multi={false}
        autoload={false}
        valueKey="ContactID"
        labelKey="Name"
        loadOptions={loadContactOptions}
        {...props} 
      />
      <Button
        style={{ color: '#121127'}}
        color="link"
        onClick={togglePopover}
        size="sm"
        id="add-contact-button"
        className="p-0 pt-1"
        hidden={props.disabled}
      >
        <Trans>+ Add New Contact</Trans>
      </Button>
      <Popover target="#add-contact-button" placement="bottom">
        <PopoverBody>
          <input
            className="form-control"
            onChange={setNewContact}
            value={newContact}
            placeholder={t("Contact Name")}
          />
          <div className="d-flex justify-content-end pt-1">
            <Button
              size="sm"
              disabled={!newContact}
              color="success"
              onClick={handleAddNewContact}
            >
              <Trans>Confirm</Trans>
            </Button>
          </div>
        </PopoverBody>
      </Popover>
    </div>
  )
);

export const withContactSearch = ({ debounce = 500 } = {}) =>
  compose(
    withTranslation(),
    withPopover(),
    (BaseComponent) =>
      class extends React.Component {
        debouncedLoadContactOptions = d((input, callback) => {
          input = input.replace(/"/g, "");
          if (!input) return callback(null, []);

          this.props.xero
            .get("contacts", {
              params: {
                raw: `Name.ToLower().Contains("${input}")`,
                page: 1,
              },
            })
            .then((resp) => callback(null, { options: resp.data }))
            .catch(callback);
        }, debounce);

        loadContactOptions = (...args) =>
          this.debouncedLoadContactOptions(...args);

        renderContactSearch = (props) => {
          return (
            <ContactSearch
              dispatch={this.props.dispatch}
              loadContactOptions={this.loadContactOptions}
              {...props}
            />
          );
        };

        render = () => (
          <BaseComponent
            {...this.props}
            loadContactOptions={this.loadContactOptions}
            ContactSearch={this.renderContactSearch}
          />
        );
      }
  );

export default withContactSearch;
